(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-mobile-query.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-mobile-query.js');

'use strict';

const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const useMobileQuery = overrideQuery => {
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return typeof overrideQuery === 'boolean' ? overrideQuery : isMobileQuery;
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useMobileQuery', useMobileQuery);

 })(window);